import http from '../services/http';

import {
    GET_REFERRAL_STATS_ENDPOINT
} from '../services/endpoints';

export default (() => {

    const getReferralStats = () => {

        return http.get(GET_REFERRAL_STATS_ENDPOINT);
    };

    return {
        getReferralStats
    };

})();


// WEBPACK FOOTER //
// ./services/stats.js